import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
// components

import Iconify from "../components/iconify";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Editor } from "react-draft-wysiwyg";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

const defaultContent = {
  content: EditorState.createEmpty(),
};
export default function PageEditPage() {
  const navigate = useNavigate();
  const [pagesId, setPageId] = useState(null);
  const [state, setState] = useState(defaultContent);
  const [value, setValue] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("pagesId")) {
      let pagesId = searchParams.get("pagesId");
      setPageId(pagesId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/${pagesId}`)
        .then(function (response) {
          let state = defaultContent;
          const html = `${response.data.page[`content`]}`.toString();
          const contentBlock = htmlToDraft(html);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(
              contentBlock.contentBlocks
            );
            state[`content`] =
              EditorState.createWithContent(contentState);
          }
          setState({ ...state });
        });
    }
  }, [searchParams, pagesId]);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      [`content`]: event,
    }));
  };

  const saveHandler = () => {
    let page = {
      content: draftToHtml(
        convertToRaw(state[`content`].getCurrentContent())
      )
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/${pagesId}`, page)
      .then((response) => {
        setState(defaultContent);
        navigate(`/dashboard/pages`);
      });
  };

  return (
    <>
      <Helmet>
        <title> Page Edit </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            PageEdit
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => saveHandler()}
            sx={{ mr: 2 }}
          >
            Save
          </Button>
        </Stack>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
          >
            <Tab label="English" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content}
              onEditorStateChange={(e) => handleChange(e, "en")}
            />
          </Card>
        </TabPanel>
      </Container>
    </>
  );
}
